var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:[_vm.iconClass, _vm.clickable ? 'pointer' : ''],style:({ color: _vm.color, flexShrink: 0 }),attrs:{"width":_vm.width,"height":_vm.width},on:{"click":function($event){return _vm.$emit('click')}}},[_c('use',{attrs:{"xlink:href":_vm.iconHref}})])
}
var staticRenderFns = []

export { render, staticRenderFns }